/**
 * Trạng thái hồ sơ
 */
export default {
  WaitReceive: 0, // Chờ tiếp nhận
  WaitAdmission: 1, // Chờ xét tuyển
  WaitUpdate: 2, // Chờ bổ sung
  Elect: 3, // Trúng tuyển
  NotElect: 4, // Không trúng tuyển,
  Admission: 5, // Đã nhập học
}
